import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getClientCohorts } from 'api/generated/client-cohorts/client-cohorts';
import type { ClientCohortDto } from 'api/generated/schemas';

import { AI_ASSISTANT_COHORTS_KEY } from '../ai-assistant.constants';

interface UseApiGetCohortsArgs {
  oktaUserId: string;
  clientId: string | number;
  enabled?: boolean;
}

export const useApiGetCohorts = ({
  oktaUserId,
  clientId,
  enabled = true,
}: UseApiGetCohortsArgs): UseQueryResult<ClientCohortDto[], unknown> =>
  useQuery({
    queryKey: [AI_ASSISTANT_COHORTS_KEY, oktaUserId, clientId],
    queryFn: () => getClientCohorts(oktaUserId, Number(clientId)),
    enabled: enabled && !!oktaUserId && !!clientId,
  });
